import _ from "lodash"

const nameFieldsToFullName = (state, relativePath) => {
  return [
    _.get(state, `${relativePath}.firstName.value`)?.trim(),
    _.get(state, `${relativePath}.middleInitial.value`)?.trim(),
    _.get(state, `${relativePath}.lastName.value`)?.trim()
  ]
      .filter(Boolean)
      .join(' ')
}
export default nameFieldsToFullName